"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosSkuAlteradoManual = void 0;
var DadosSkuAlteradoManual = /** @class */ (function () {
    function DadosSkuAlteradoManual() {
        this._id = {
            material: '',
            data: '',
            estacao: '',
            colecao: '',
            grade: '',
        };
    }
    return DadosSkuAlteradoManual;
}());
exports.DadosSkuAlteradoManual = DadosSkuAlteradoManual;
//# sourceMappingURL=DadosSkuAlteradoManual.js.map